<ng-http-loader [backdrop]="true" [backgroundColor]="'#ff0000'" [backdropBackgroundColor]="'#ffffff'" [opacity]="0.3"
  [spinner]="spinkit.skThreeBounce">
</ng-http-loader>


<div class="container-fluid" *ngIf="!OrderPlaced">
  <div class="row" style="padding-top: 20px;padding-bottom: 20px; background: #FCFCFC;">
    <img src="/assets/img/backMenu.svg" alt="" (click)="goToMenu()" style="margin-left: 3%;cursor: pointer;"> <span
      class="order-history">Order History</span>
  </div>
</div>

<div *ngIf="noOrders">
  <div class="container">
    <div class="no-orders-img">
      <img src="assets/img/empty_order.svg" alt="">
    </div>
    <div class="no-orders-text">
      <div class="kitchen-text">Kitchen is waiting for <br> your order</div>
      <div class="ourCheifText">Our Chef is waiting to give healthy food </div>
    </div>
  </div>
</div>

<!-- Section to show the gif for preparing the order,commented because of no status we have as of now
   <div *ngIf="userNotYetOrdered">
  <div class="container ">
    <div class="d-flex justify-content-between pad-top-10">
      <div class="no-orders-text">
        <div class="kitchen-text-not-ordered">Kitchen is waiting for your order</div>
        <div class="our-chef-text-not-ordered">Our Chef is waiting to give healthy food </div>
      </div>
      <div class="">
        <img src="assets/img/empty_order.svg" alt="">
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="underline">
      &nbsp;
    </div>
  </div>
</div> -->


<!-- Section to show the gif for preparing the order,commented because of no status we have as of now
   <div *ngIf="userOrdered">
  <div class="container ">
    <div class="d-flex justify-content-between pad-top-10">
      <div class="no-orders-text">
        <div class="kitchen-text-not-ordered">Kitchen has received your order</div>
        <div class="our-chef-text-not-ordered">Want to make changes to your order? Speak to chef? </div>
      </div>
      <div class="">
        <img src="assets/img/recieved.svg" alt="" class="received-image">
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="underline">
      &nbsp;
    </div>
  </div>
</div> -->

<!-- Section to show the gif for preparing the order,commented because of no status we have as of now
  <div class="container">
  <div class="order-for-table">Order for table 023</div>

  <div class="orders-placed-container">
    <div class="orders-div">
      <div class="order-number">Order No: 0124</div>
      <div class="preparing">Preparing</div>
    </div>

    <div class="orders-div pad-top-2">
      <div class="ordered-items-details ">2x Chicken Biriyani <span class="ordered-item-price">£
          10</span>
      </div>
    </div>

    <div class="d-flex justify-content-end margin-t25">
      <img src="assets/img/preparing.gif" alt="" width="80px">
    </div>
  </div>
</div> -->

<div class="container padding-bottom" *ngIf="!OrderPlaced">
  <div class="previous-orders"> Previous Orders</div>
  <div *ngFor="let item of placedOrdersArray">
    <div class="orders-container">
      <div class="orders-div cursor" (click)="showParticularOrderDetails(item.order_id)">
        <div class="order-number">Order No: {{item.order_no}}</div>
        <div class="completed" *ngIf="item.order_status == 'Completed'">Completed</div>
      </div>

      <div *ngFor="let itemSub of item.orderitems">
        <div class="orders-div cursor" (click)="showParticularOrderDetails(item.order_id)">
         <div class="ordered-items-details">{{itemSub.quantity}}x {{itemSub.dish_name}} <span class="ordered-item-price">£
              {{itemSub.price_per_item}}</span>
         </div>
        </div>

        <div class="orders-div margt-20">
          <div>
            <div *ngIf="itemSub.reviewed == 'No'" class="reviewed-text review-border" (click)="goToPostReview(itemSub.dish_name,item.order_id,itemSub.order_item_id , itemSub.dish_id)">
              Review <span><img src="../../../../assets/img/white-star-set.svg" alt=""></span>
            </div>
            <div *ngIf="itemSub.reviewed != 'No'" class="reviewed-text">
              Reviewed <span><img src="../../../../assets/img/start-icon.svg" alt="">
                <img src="../../../../assets/img/start-icon.svg" alt="">
                <img src="../../../../assets/img/start-icon.svg" alt="">
                <img src="../../../../assets/img/start-icon.svg" alt="">
                <img src="../../../../assets/img/start-icon.svg" alt="">
              </span>
            </div>
          </div>
          <div class="ordered-item-date" (click)="showParticularOrderDetails(item.order_id)">{{item.order_created_on}}</div>
        </div>
      </div>
    </div>
  </div>
</div>

<div>
  <div *ngIf="OrderPlaced">
    <div class="container-fluid">
      <div class="row" style="padding-top: 15px;padding-bottom: 10px; background: #FCFCFC;">
        <img src="/assets/img/backMenu.svg" alt="" (click)="goToOrdersHistory()" style="margin-left: 3%;cursor: pointer;"> <span
          class="order-title">Order Completed</span> <span><img src="../../../../assets/img/succes.png" width="26px"
            style="margin-left: 10px;" alt=""></span>
      </div>
    </div>
  
    <div class="container-fluid">
      <div style="background: #F2F5F7;margin-top: 7%;">
        <div class="billdetails">
          Bill Details
        </div>
      </div>
    </div>
  
    <div class="container">
      <div class="" style="margin-top: 15px;">
        <div class="restoNamenew">{{restoName}}</div>
        <div class="ordNo">Order No : #{{orderDetailsorderId}} </div>
      </div>
  
      <div class="" style="margin-top: 15px;">
        <div *ngFor="let orditems of OrderDetails;let i = index">
          <div *ngIf="orditems.order_item_option.length >= 1">
            <div>
              <div class="itemsNamePA">{{i+1}}. {{orditems.dish_name}}</div>
              <div class="d-flex justify-content-between">
                <div *ngFor="let addons of orditems.order_item_option" style="margin-left: 14px;">
                  <div class="addonVariantTitle">Variant: <span class="addonOptionName">{{addons.option_name}}</span>
                  </div>
                </div>
                <div *ngFor="let addons of orditems.order_item_option">
                  <div class="itemsNamePA">£ {{value_coupon(orditems.order_item_single_price) }}</div>
                </div>
              </div>
  
              <div>
                <div *ngFor="let addons of orditems.order_item_addOn" style="margin-left: 14px;"
                  class="d-flex justify-content-between">
                  <div class="addonVariantTitle">Add Ons: <span class="addonOptionName">{{addons.addon_name}}</span>
                  </div>
                  <div class="itemsNamePA">£ {{value_coupon(addons.addon_option_price) }}</div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="orditems.order_item_option.length == 0">
            <div class="d-flex justify-content-between" style="margin-top: 10px;">
              <div class="itemsNamePA">{{i+1}}. {{orditems.dish_name}} <span style="margin-left: 15px;">
                  x{{orditems.quantity}}</span></div>
              <div class="itemsNamePA">£ {{value_coupon(orditems.order_item_single_price * orditems.quantity ) }}</div>
            </div>
          </div>
        </div>
        <div style="border-bottom:1px dashed gray;margin-top: 10px;"></div>
      </div>
  
      <div class="">
        <div class="d-flex justify-content-between" style="margin-top: 10px;">
          <div class="totalItemPA">Item total</div>
          <div class="totalItemPA">£ {{value_coupon(totalPrice)}}</div>
        </div>
        <hr style="width: 100%;margin-top: 10px;">
      </div>
  
      <div class="">
        <div class="d-flex justify-content-between" style="margin-top: 10px;">
          <div class="itemsNamePA">Amount Paid</div>
          <div class="itemsNamePA">£ {{value_coupon(totalPrice)}}</div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- 6363285503 -->

<!-- <div class="container">
  <app-bottommenu></app-bottommenu>
</div> -->

<div class="container-fluid">
  <div class="d-flex justify-content-between">
    <div *ngIf="UserCondition">
      <ul class=" nav nav-pills d-flex justify-content-between">
        <li class="nav-item col-xs-3">
          <a [routerLink]="['../', 'food-menu']" routerLinkActive="active" class="nav-link" #rla="routerLinkActive">
            <img [src]="rla.isActive ? iconmenu : iconAtvmenu" alt="menu" />
            <span class="nav__text">Menu</span>
          </a>
        </li>
        <li class="nav-item col-xs-3">
          <a [routerLink]="['../', 'order-menu']" routerLinkActive="active" class="nav-link"
            #rlas="routerLinkActive"><span class="lengthsSpan" *ngIf="lengths > 0">{{lengths}}</span>
            <img [src]="rlas.isActive ? iconcart : iconAtvcart" alt="">
            <span class="nav__text">Cart</span>
          </a>
        </li>

        <li class="nav-item col-xs-3">
          <a [routerLink]="['../',  'myOrders']" routerLinkActive="active" class="nav-link" #rlag="routerLinkActive">
            <img [src]="rlag.isActive ? iconorder : iconAtvorder" alt="">

            <span class="nav__text">Orders</span>
          </a>
        </li>

        <li class="nav-item col-xs-3 py-1">
          <a [routerLink]="['../', 'profile']" routerLinkActive="active" class="nav-link" #rlap="routerLinkActive">
            <img [src]="rlap.isActive  ? iconprofile : iconAtvprofile " alt="">
            <span class="nav__text">Profile</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
  <div class="d-flex justify-content-between">
    <div *ngIf="!UserCondition">
      <ul class=" nav nav-pills d-flex justify-content-between">
        <li class="nav-item col-xs-3">
          <a [routerLink]="['../', 'food-menu-guest']" routerLinkActive="active" class="nav-link"
            #rla="routerLinkActive">
            <img [src]="rla.isActive ? iconmenu : iconAtvmenu" alt="menu" />
            <span class="nav__text">Menu</span>
          </a>
        </li>
        <li class="nav-item col-xs-3">
          <a (click)="getLoginScreen()" routerLinkActive="active" class="nav-link" #rlas="routerLinkActive"><span
              class="lengthsSpan" *ngIf="lengths > 0">{{lengths}}</span>
            <img [src]="rlas.isActive ? iconcart : iconAtvcart" alt="">
            <span class="nav__text">Cart</span>
          </a>
        </li>
        <li class="nav-item col-xs-3">
          <a [routerLink]="['../',  'myOrders']" routerLinkActive="active" class="nav-link" #rlag="routerLinkActive">
            <img [src]="rlag.isActive ? iconorder : iconAtvorder" alt="">

            <span class="nav__text">Orders</span>
          </a>
        </li>
        <li class="nav-item col-xs-3 py-1">
          <a (click)="getLoginScreen()" routerLinkActive="active" class="nav-link" #rlap="routerLinkActive">
            <img [src]="rlap.isActive  ? iconprofile : iconAtvprofile " alt="">
            <span class="nav__text">Profile</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>